import * as React from "react";
import {ModalLayout} from "../../shared/modal-layout";
import {MaterialCommunityIcons} from "@expo/vector-icons";
import {Text, View} from "react-native";
import {CheckBox} from "@ui-kitten/components";
import {AsyncButtonWithSpinner} from "../../shared/async-button-with-spinner";

export const ModalAskPickup = ({
                                   closeModal: _closeModal,
                                   onSubmit
                               }) => {
    const [isCertifyBinFull, setCertifyBinFull] = React.useState(false)
    const closeModal = () => {
        _closeModal();
        setCertifyBinFull(false)
    }

    return <ModalLayout title="Ask for pick up" icon={<MaterialCommunityIcons name="dump-truck" size={40} color="#a0c946"/>}
                        close={closeModal}>

        <Text style={{marginBottom: 10}}>WeCycle will schedule and advise a pick up date as soon as we receive your pick up request</Text>

        <View style={{height:1, backgroundColor: '#a0c946', marginBottom: 20 }} />

        <View style={{flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 5}}>
            <Text style={{fontWeight: 'bold'}}>I certify that my bin(s) is/are full</Text>
            <CheckBox
                checked={isCertifyBinFull} onChange={() => setCertifyBinFull(!isCertifyBinFull)}>

            </CheckBox>
        </View>
        {isCertifyBinFull && <AsyncButtonWithSpinner onWhite={true} onPress={async () => {
            await onSubmit();
            closeModal()
        }}>Send my pick up request</AsyncButtonWithSpinner>}
    </ModalLayout>
}